module.exports = __webpack_public_path__ + "img/icon-edit.519dd4a5.svg";